import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';

const { FiArrowUpRight } = FiIcons;

const BlogCard = ({ blog }) => {
  const publishedDate = new Date(`${blog.datePublished}T00:00:00`);

  return (
    <article>
      <Link
        to={`/journal/${blog.slug}`}
        aria-label={`Read ${blog.title}`}
        className="group block focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black"
      >
        <div className="relative aspect-[4/3] overflow-hidden bg-white">
          <img
            src={blog.image}
            alt={`Scene from Lost Boys Musical featured in ${blog.title}`}
            loading="lazy"
            decoding="async"
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>

        <div className="border-b-2 border-black py-6">
          <div className="mb-3 flex items-center justify-between font-mono text-[10px] font-black uppercase tracking-widest">
            <span>The Lost Boys</span>
            <span className="flex items-center gap-2">
              <span>{blog.issue}</span>
              <SafeIcon
                icon={FiArrowUpRight}
                className="text-base transition-transform duration-300 group-hover:rotate-45"
                aria-hidden="true"
              />
            </span>
          </div>
          <p className="mb-3 font-mono text-[10px] font-black uppercase tracking-widest">
            Published{' '}
            <time dateTime={blog.datePublished}>
              {publishedDate.toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              })}
            </time>
          </p>
          <h2 className="break-words font-serif text-3xl font-black uppercase italic leading-[0.9] transition-all group-hover:pl-3 md:text-4xl">
            {blog.title}
          </h2>
          <p className="mt-5 max-w-xl font-mono text-xs leading-relaxed text-black/70">
            {blog.excerpt}
          </p>
        </div>
      </Link>
    </article>
  );
};

export default BlogCard;